var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.031,
    height: 13.723,
    viewBox: "0 0 7.031 13.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "angle-small-left",
    d: "M13.1,12.557a.98.98,0,0,0,0-1.392L8.6,6.676A.981.981,0,0,1,9.985,5.284l4.5,4.5a2.941,2.941,0,0,1,0,4.156l-4.5,4.5A.981.981,0,1,1,8.6,17.047Z",
    transform: "translate(-8.313 -4.999)",
    fill: "#1d2432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.81338a8473f9cfd91f5018d8938068ef.svg";
export { ForwardRef as ReactComponent };